// Utility functions for handling image URLs
export const getImageUrl = (url) => {
  console.log('=== getImageUrl called ===');
  console.log('Input URL:', url);
  console.log('Type of URL:', typeof url);
  
  if (!url) {
    console.log('No URL provided to getImageUrl');
    return null;
  }
  
  // If URL is already absolute, return as is
  if (url.startsWith('http')) {
    console.log('URL is already absolute:', url);
    return url;
  }
  
  // If URL starts with /uploads/, prepend the API base URL
  if (url.startsWith('/uploads/')) {
    const apiUrl = process.env.REACT_APP_API_URL;
    if (!apiUrl) {
      throw new Error('REACT_APP_API_URL environment variable is required. Please set it in your environment variables.');
    }
    const fullUrl = `${apiUrl}${url}`;
    console.log('API URL:', apiUrl);
    console.log('Constructed full image URL:', fullUrl);
    return fullUrl;
  }
  
  // For relative URLs, prepend /uploads/ and API base URL
  const apiUrl = process.env.REACT_APP_API_URL;
  if (!apiUrl) {
    throw new Error('REACT_APP_API_URL environment variable is required. Please set it in your environment variables.');
  }
  const fullUrl = `${apiUrl}/uploads/${url}`;
  console.log('API URL (fallback):', apiUrl);
  console.log('Constructed relative image URL:', fullUrl);
  return fullUrl;
};

// Get a placeholder image URL for events
export const getEventPlaceholderImage = () => {
  return 'https://via.placeholder.com/400x200?text=Event+Image';
};

// Get a placeholder image URL for vendor profiles
export const getVendorPlaceholderImage = () => {
  return 'https://via.placeholder.com/300x200?text=Vendor+Profile';
};
